import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { contentfulViews } from '@glowforge/ui-common';
import _ from 'lodash';
import { pagePropType } from 'app/common/selectors/page';
import OrderDetails from './order-details';

import './confirmation-page.less';

const { Page } = contentfulViews;

class ConfirmationPage extends Component {
  componentDidMount() {
    window.GTM_NEW_ORDER_CONFIG = _.get(this.props, 'gtmNewOrderConfig');
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(_.get(this.props, 'gtmNewOrderConfig'));
  }

  render() {
    const customSections = {
      'glowforge-order-summary': {
        component: OrderDetails,
        props: {
          priceSummary: _.get(this.props, 'priceSummary'),
          shippingSummary: _.get(this.props, 'shippingSummary'),
          orderNumber: this.props.params.orderNumber,
        },
      },
    };

    const stringSubstitutions = [
      { name: 'email', value: _.get(this.props, 'orderEmail') },
      { name: 'referral-url', value: this.props.referralURL },
    ];

    return (
      <Page className='ConfirmationPage' {...this.props.page} customSections={customSections} stringSubstitutions={stringSubstitutions} />
    );
  }
}

ConfirmationPage.propTypes = {
  page: PropTypes.shape(pagePropType).isRequired,
  orderNumber: PropTypes.string.isRequired,
  params: PropTypes.shape({ orderNumber: PropTypes.string.isRequired }).isRequired,
  referralURL: PropTypes.string.isRequired,
};

export default ConfirmationPage;



// WEBPACK FOOTER //
// ./app/store/components/glowforge/confirmation/confirmation-page.jsx